import PropTypes from 'prop-types'
import { SORT_DIRECTION } from '../../utils/common'
import { UseI18n } from '../hooks/useI18n'
import { Style } from '../html/Style'
import { Element } from '../html/element'
import { Icon } from '../html/icon'
import classes from './index.module.scss'

export const ThCell = ({
  col,
  sticky,
  colSpan,
  rowSpan,
  sort,
  changeSort,
  style,
  isNoStickyHead,
}) => {
  const renderTitle = () => {
    const titleWithI18n = col.isI18n ? UseI18n(col.title) : col.title
    const titleWithHtml = col.isHtml ? (
      <div dangerouslySetInnerHTML={{ __html: titleWithI18n }} />
    ) : (
      titleWithI18n
    )

    return col.renderTh ? col.renderTh(titleWithHtml) : titleWithHtml
  }

  const getStyleStickyCol = () => {
    const style = {}

    if (sticky) {
      style.left = 0
      style.zIndex = 3
    }

    return style
  }

  const renderSortIcons = () => {
    return (
      <Element className={classes.sortIcons}>
        {Object.keys(SORT_DIRECTION).map((key) => (
          <Icon
            key={key}
            className={
              SORT_DIRECTION[key] === SORT_DIRECTION.ASC
                ? 'icon-arrow-top-bold'
                : 'icon-arrow-bottom-bold'
            }
            style={{
              fontSize: 6,
              color:
                sort &&
                sort.sortBy === col.colId &&
                sort.sortDirection === SORT_DIRECTION[key]
                  ? '#2C73E8'
                  : '#3A414B',
            }}
          />
        ))}
      </Element>
    )
  }

  const handleClickTitle = () => {
    if (!col.sortable || !sort) return

    const newSort = { sortBy: col.colId }

    if (sort.sortBy === col.colId) {
      switch (sort.sortDirection) {
        case SORT_DIRECTION.DESC:
          newSort.sortDirection = SORT_DIRECTION.ASC
          break
        case SORT_DIRECTION.ASC:
          newSort.sortDirection = undefined
          newSort.sortBy = undefined
          break
        default:
          newSort.sortDirection = SORT_DIRECTION.DESC
          break
      }
    } else {
      newSort.sortDirection = SORT_DIRECTION.DESC
    }

    changeSort(newSort)
  }

  return (
    <Style
      className={isNoStickyHead ? '' : classes.tableStickyHead}
      pseudo="before"
      attr="background-color"
      color="#d5d5d5"
    >
      <Element
        elementName="th"
        colSpan={colSpan ? colSpan : 1}
        rowSpan={rowSpan ? rowSpan : 1}
        className={isNoStickyHead ? '' : classes.tableStickyHead}
        style={{
          backgroundColor: '#FFFFFF',
          borderBottomColor: '#D5D5D5',
          ...style,
          ...getStyleStickyCol(),
          ...col.parentThStyle,
        }}
      >
        <Element
          className={`dFlex alignItemsCenter gap1 ${
            col.sortable ? 'cursorPointer' : ''
          }`}
          onClick={handleClickTitle}
          style={col?.thStyle}
        >
          {renderTitle()}
          {col.sortable && renderSortIcons()}
        </Element>
      </Element>
    </Style>
  )
}

ThCell.propTypes = {
  col: PropTypes.object.isRequired,
  sticky: PropTypes.bool,
  isNoStickyHead: PropTypes.bool,
  style: PropTypes.object,
  sort: PropTypes.shape({
    sortBy: PropTypes.string,
    sortDirection: PropTypes.string,
  }),
  changeSort: PropTypes.func,
  textAlignHeader: PropTypes.string,
}

ThCell.defaultProps = {
  sticky: false,
  isNoStickyHead: false,
}
